module.exports = __webpack_public_path__ + "static/bf_vector-58249d3650b5429435f6412f630b723f.png";